import { render, staticRenderFns } from "./chat-record-select.vue?vue&type=template&id=775d1e9e&"
import script from "./chat-record-select.vue?vue&type=script&lang=js&"
export * from "./chat-record-select.vue?vue&type=script&lang=js&"
import style0 from "./chat-record-select.vue?vue&type=style&index=0&id=775d1e9e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports